import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {selectDeal} from 'api/deals';
import {loadInterestDeal as load, submitInterestDeal as submit} from 'flows/interest/deal/index';

import Spinner from 'components/Spinner';
import DealSummary from 'components/DealSummary';

export class InterestDealContainer extends React.Component {
  constructor() {
    super();
    this.next = this.next.bind(this);
  }
  componentDidMount() {
    const {after, inviteId, dealId, confirm} = this.props.params;
    const invite = {id: inviteId};
    const deal = {id: dealId};

    this.props.load({invite, deal, after, confirmationToast: confirm});
  }
  next() {
    this.props.submit({id: this.props.params.dealId});
  }
  render() {
    const {data, loaded} = this.props.deal || {};

    if (loaded) {
      return (
        <DealSummary next={this.next} deal={data} nextButtonText="Invest" />
      );
    }
    return (
      <Spinner />
    );
  }
}

InterestDealContainer.propTypes = {
  load: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  deal: PropTypes.object,
  params: PropTypes.object.isRequired,
};

export const mapStore = (store, ownProps) => ({
  deal: selectDeal(store, ownProps.params.dealId)
});

export default connect(mapStore, {load, submit})(InterestDealContainer);



// WEBPACK FOOTER //
// ./web/flows/interest/deal/index.js